import { Link } from 'react-router-dom';
import { Category } from 'TYPES/api.body';

interface Props {
  categories: Category[];
}

const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// Helper function to get fallback image based on category name
const getFallbackImage = (categoryName: string): string => {
  const name = categoryName.trim().toLowerCase();

  // Active categories
  if (name.includes('grocery') || name.includes('groceries') || name.includes('supermarket') || name.includes('market')) {
    return '/images/categories/groceries.png';
  }
  if (name.includes('pharmacy') || name.includes('medical') || name.includes('health') || name.includes('medicine')) {
    return '/images/categories/pharmacy.png';
  }

  // Robust electronics/electrical matching
  if (
    name.includes('electronics') ||
    name.includes('tech') ||
    name.includes('gadget') ||
    name.includes('electrical accessories') ||
    (name.includes('electrical') && name.includes('accessories'))
  ) {
    return '/images/categories/electronics.png';
  }
  // Default fallback
  return '/images/categories/default.png';
};

// Helper function to check if category should be displayed
const shouldDisplayCategory = (categoryName: string): boolean => {
  const name = categoryName.toLowerCase();
  return (
    name.includes('grocery') ||
    name.includes('groceries') ||
    name.includes('supermarket') ||
    name.includes('market') ||
    name.includes('pharmacy') ||
    name.includes('medical') ||
    name.includes('health') ||
    name.includes('medicine') ||
    name.includes('electronics') ||
    name.includes('electrical') ||
    name.includes('accessories')
  );
};

const BlobGrid: React.FC<Props> = ({ categories }) => {
  // Filter categories to only show the three main types
  const filteredCategories = categories.filter(category =>
    shouldDisplayCategory(category.name)
  );

  return (
    <div className="flex justify-center gap-8 py-10 padding-section">
      {filteredCategories.map(category => (
        <div key={category.id} className="flex flex-col items-center group">
          <Link
            className="flex flex-col items-center"
            to={`/categories/${makeSlug(category.name)}?category=${category.id}`}>
            <div className="mb-2 w-full flex justify-center overflow-hidden rounded-lg">
              <img
                src={category.logo || getFallbackImage(category.name)}
                alt={category.name}
                className="max-w-[180px] w-full h-auto object-contain transition-transform duration-300 ease-in-out group-hover:scale-110"
                onError={(e) => {
                  // If the primary image fails, use fallback
                  const target = e.target as HTMLImageElement;
                  if (target.src !== getFallbackImage(category.name)) {
                    target.src = getFallbackImage(category.name);
                  }
                }}
              />
            </div>
            {/* <span className="text-[#4D4D4D] text-lg font-bold mt-2 text-center">{category.name}</span> */}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default BlobGrid;


//main categories

// import { Link } from 'react-router-dom';
// import { Category } from 'TYPES/api.body';

// interface Props {
//   categories: Category[];
// }

// const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// // Helper function to get fallback image based on category name
// const getFallbackImage = (categoryName: string): string => {
//   const name = categoryName.toLowerCase();

//   // Active categories
//   if (name.includes('grocery') || name.includes('groceries') || name.includes('supermarket') || name.includes('market')) {
//     return '/images/categories/groceries.png';
//   }
//   if (name.includes('pharmacy') || name.includes('medical') || name.includes('health') || name.includes('medicine')) {
//     return '/images/categories/pharmacy.png';
//   }

//   // Commented out other categories
//   // if (name.includes('agriculture') || name.includes('farming')) {
//   //   return '/images/categories/agriculture.png';
//   // }
//   // if (name.includes('food') || name.includes('restaurant')) {
//   //   return '/images/categories/food.png';
//   // }
//   // if (name.includes('beauty')) {
//   //   return '/images/categories/health.png';
//   // }
//   // if (name.includes('fashion') || name.includes('clothing') || name.includes('apparel')) {
//   //   return '/images/categories/fashion.png';
//   // }
//   // if (name.includes('electronics') || name.includes('tech') || name.includes('gadget')) {
//   //   return '/images/categories/electronics.png';
//   // }
//   // if (name.includes('home') || name.includes('furniture') || name.includes('decor')) {
//   //   return '/images/categories/home.png';
//   // }
//   // if (name.includes('lottery') || name.includes('games') || name.includes('gym')) {
//   //   return '/images/categories/lottery.png';
//   // }
//   // if (name.includes('automotive') || name.includes('car') || name.includes('vehicle')) {
//   //   return '/images/categories/auto.png';
//   // }
//   // if (name.includes('event') || name.includes('Occasion') || name.includes('party')) {
//   //   return '/images/categories/events.png';
//   // }

//   // Default fallback
//   return '/images/categories/default.png';
// };

// const BlobGrid: React.FC<Props> = ({ categories }) => (
//   <div className="grid grid-cols-2 md:grid-cols-3 gap-8 py-10 padding-section">
//     {categories.map(category => (
//       <div key={category.id} className="flex flex-col items-center group">
//         <Link
//           className="flex flex-col items-center"
//           to={`/categories/${makeSlug(category.name)}?category=${category.id}`}>
//           <div className="mb-2 w-full flex justify-center overflow-hidden rounded-lg">
//             <img
//               src={category.logo || getFallbackImage(category.name)}
//               alt={category.name}
//               className="max-w-[180px] w-full h-auto object-contain transition-transform duration-300 ease-in-out group-hover:scale-110"
//               onError={(e) => {
//                 // If the primary image fails, use fallback
//                 const target = e.target as HTMLImageElement;
//                 if (target.src !== getFallbackImage(category.name)) {
//                   target.src = getFallbackImage(category.name);
//                 }
//               }}
//             />
//           </div>
//           {/* <span className="text-[#4D4D4D] text-lg font-bold mt-2 text-center">{category.name}</span> */}
//         </Link>
//       </div>
//     ))}
//   </div>
// );

// export default BlobGrid;

//old categories

// import {
//   blob,
//   fashion as fashionImg,
//   health as healthImg,
//   home as homeImg,
//   supermarket as supermarketImg
// } from 'components/molecules/blobs';
// import { Link } from 'react-router-dom';
// import { Category } from 'TYPES/api.body';

// interface Props {
//   categories: Category[];
// }

// const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// const BlobGrid: React.FC<Props> = ({ categories }) => {
//   const fashion = categories.filter(item => item.name.toLowerCase().includes('fashion')).pop();
//   const food = categories.filter(item => item.name.toLowerCase().includes('food')).pop();
//   const home = categories.filter(item => item.name.toLowerCase().includes('home')).pop();
//   const health = categories.filter(item => item.name.toLowerCase().includes('health')).pop();
//   const supermarket = categories.filter(item => item.name.toLowerCase().includes('supermarket')).pop();

//   return (
//     <div className="py-10 padding-section">
//       <div className="flex justify-between px-3">
//         <div className="flex flex-col items-center">
//           <Link
//             className="flex flex-col items-center"
//             to={food !== undefined ? `/categories/${makeSlug(food.name)}?category=${food?.id}` : '#'}>
//             <div className="blobsm blob1 mb-2 grid place-content-center hover:border-violet-800">
//               <img src={blob} alt="blob" width={70} height={70} />
//             </div>
//             <span className="text-[#4D4D4D] text-lg font-bold">Food</span>
//           </Link>
//         </div>
//         <div className="flex flex-col items-center ">
//           <Link
//             className="flex flex-col items-center"
//             to={fashion !== undefined ? `/categories/${makeSlug(fashion.name)}?category=${fashion?.id}` : '#'}>
//             <div className="blobsm blob2 mb-2 grid place-content-center hover:border-blue-600">
//               <img src={fashionImg} alt="blob" width={70} height={70} />
//             </div>
//             <span className="text-[#4D4D4D] text-lg font-bold">Fashion</span>
//           </Link>
//         </div>
//       </div>
//       <div className="flex justify-center items-center">
//         <div className="flex flex-col items-center">
//           <Link
//             className="flex flex-col items-center"
//             to={
//               supermarket !== undefined ? `/categories/${makeSlug(supermarket.name)}?category=${supermarket?.id}` : '#'
//             }>
//             <div className="blobsm blob3 mb-2 grid place-content-center hover:border-amber-800">
//               <img src={supermarketImg} alt="blob" width={70} height={70} />
//             </div>
//             <span className="text-[#4D4D4D] text-lg font-bold">Supermarket</span>
//           </Link>
//         </div>
//       </div>
//       <div className="flex justify-between">
//         <div className="flex flex-col items-center">
//           <Link
//             className="flex flex-col items-center"
//             to={home !== undefined ? `/categories/${makeSlug(home.name)}?category=${home?.id}` : '#'}>
//             <div className="blobsm blob4 mb-2 grid place-content-center  hover:border-orange-600">
//               <img src={homeImg} alt="blob" width={70} height={70} />
//             </div>
//             <span className="text-[#4D4D4D] text-lg font-bold">Home & Office</span>
//           </Link>
//         </div>
//         <div className="flex flex-col items-center">
//           <Link
//             className="flex flex-col items-center"
//             to={health !== undefined ? `/categories/${makeSlug(health.name)}?category=${health?.id}` : '#'}>
//             <div className="blobsm blob5 mb-2 grid place-content-center hover:border-green-400">
//               <img src={healthImg} alt="blob" width={70} height={70} />
//             </div>
//             <span className="text-[#4D4D4D] text-lg font-bold">Health & Beautyy</span>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlobGrid;
